import React from 'react'
import PropTypes from 'prop-types'

const Spacer = ({ height = 10, width = 10 }) => <div style={{ height: `${height}px`, width: `${width}px` }} />

Spacer.propTypes = {
    height: PropTypes.number,
    width: PropTypes.number,
}

export default Spacer
